define( function() {
	"use strict";

	return ( /^$|\/(?:java|ecma)script/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rscriptType.js
// module id = 1816
// module chunks = 36